import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/core/interfaces/store';

const analyticsSelector = (state: RootState) => state.analytics;

export const isAnalyticsDashboardOpenSelector = createSelector(
  analyticsSelector,
  state => state.isAnalyticsDashboardOpen
);

export const getIsExpandedSelector = createSelector(analyticsSelector, state => state.isExpanded);

export const getTimeFrameSelector = createSelector(analyticsSelector, state => state.timeFrame);

export const getWidgetOrderSelector = createSelector(analyticsSelector, state => state.widgetOrder);

export const getVolumeOverTimeFilterSelector = createSelector(
  analyticsSelector,
  state => state.volumeOverTimeFilter
);

export const getVolumeByCountryFilterSelector = createSelector(
  analyticsSelector,
  state => state.volumeByCountryFilter
);

export const getHeatmapCategoryIdSelector = createSelector(
  analyticsSelector,
  state => state.heatmapCategoryId
);

export const getVolumeOverTimeChartSelector = createSelector(
  analyticsSelector,
  state => state.charts.volumeOverTime
);

export const getModalityDistributionChartSelector = createSelector(
  analyticsSelector,
  state => state.charts.modalityDistribution
);

export const getPreciseHeatmapChartSelector = createSelector(
  analyticsSelector,
  state => state.charts.preciseHeatmap
);

export const getVolumeByCountryChartSelector = createSelector(
  analyticsSelector,
  state => state.charts.volumeByCountry
);

export const getHeatmapCategoriesWithDataSelector = createSelector(
  analyticsSelector,
  state => state.heatmapCategoriesWithData
);

export const getVolumeByCountryCategoriesWithDataSelector = createSelector(
  analyticsSelector,
  state => state.volumeByCountryCategoriesWithData
);

export const getVolumeByCountrySelectedCategoryIdSelector = createSelector(
  analyticsSelector,
  state => state.volumeByCountrySelectedCategoryId
);
